module.exports = __webpack_public_path__ + "static/media/adult-airport-backpack.e2316905.jpg";